// client/src/features/auth/PersistLogin.js

import {
  Outlet,
} from 'react-router-dom';

import {
  useEffect,
  useRef,
} from 'react';

import {
  useSelector,
} from 'react-redux';

import PulseLoader from 'react-spinners/PulseLoader';

import {
  useRefreshMutation,
} from './authApiSlice';

import {
  selectCurrentToken,
} from './authSlice';

import usePersist from '../../hooks/usePersist';


const PersistLogin = () => {
  const [
    persist,
  ] =
    usePersist();

  const token =
    useSelector(
      selectCurrentToken
    );

  const refreshAttempted =
    useRef(false);


  const [
    refresh,
    {
      isLoading,
    },
  ] =
    useRefreshMutation();


  useEffect(() => {
    /*
     * Prevent the React 18 StrictMode
     * development double-effect from
     * requesting two refreshes.
     */
    if (
      refreshAttempted.current
    ) {
      return;
    }

    refreshAttempted.current =
      true;


    /*
     * Already authenticated or the user
     * did not choose "Trust This Device".
     */
    if (
      token ||
      !persist
    ) {
      return;
    }


    const verifyRefreshToken =
      async () => {
        try {
          await refresh()
            .unwrap();
        } catch (error) {
          /*
           * This is intentionally NOT fatal.
           *
           * An expired refresh cookie should
           * simply mean the user is anonymous.
           *
           * Public routes remain accessible.
           * RequireAuth will continue protecting
           * /console, /orders, etc.
           */
          console.log(
            'No valid persisted session'
          );
        }
      };


    verifyRefreshToken();
  }, [
    persist,
    refresh,
    token,
  ]);


  /*
   * While attempting to restore a trusted
   * session, wait before rendering so the
   * Navbar doesn't briefly show "Log In".
   */
  if (
    persist &&
    !token &&
    isLoading
  ) {
    return (
      <div
        style={{
          width:
            '100%',

          minHeight:
            '100vh',

          display:
            'flex',

          alignItems:
            'center',

          justifyContent:
            'center',
        }}
      >
        <PulseLoader
          color="#FFF"
        />
      </div>
    );
  }


  /*
   * Whether refresh succeeded or failed,
   * continue rendering.
   *
   * Protected routes are the responsibility
   * of RequireAuth.
   */
  return (
    <Outlet />
  );
};


export default PersistLogin;